module.exports = __webpack_public_path__ + "img/1455061124.71436c4e.jpg";